import { useEffect, useState } from "react";
import { toastSuccess } from "../../../components/base/Toast";
import DropDown from "../../../components/form/DropDown";
import Form from "../../../components/form/Form";
import TextBox from "../../../components/form/TextBox";
import ToggleSwitch from "../../../components/form/ToggleSwitch";
import { API_ROUTES } from "../../../core/Constants";
import { useHub } from "../../../core/Global";
import User from "../models/User";
import Icon from "../../../components/base/Icon";


type Props = {
    model?: User
}

export default function CustomersSettings(props: Props) {

    const hub = useHub()
    const [working, workingSet] = useState<boolean>(false)
    const [customSubscriptionCharge, customSubscriptionChargeSet] = useState<boolean>(false)


    useEffect(() => {
        if (props.model?.customSubscriptionCharge) customSubscriptionChargeSet(true)
        else customSubscriptionChargeSet(false)
    }, [props.model])

    return (
        <Form className="form"
            onSubmit={(body, callback) => {
                workingSet(true)
                hub.Post("/accounts/customers/settings", {
                    ...body,
                    id: props.model?.id
                }, res => {
                    if (res.success) {
                        toastSuccess("Customer settings has been updated successfully!");
                    }
                    if (callback) callback(res);
                    workingSet(false)
                });
            }}>
            <div className="card mb-5 mb-xl-10">
                <div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#kt_account_notifications" aria-expanded="true" aria-controls="kt_account_notifications">
                    <div className="card-title m-0">
                        <h3 className="fw-bolder m-0">
                            Customer Settings
                        </h3>
                    </div>
                    <div className="card-action">
                        <button type="submit" className="btn btn-sm btn-primary" disabled={working}>
                            {
                                working ?
                                    <>
                                        <Icon icon="spinner-third" spin />
                                        <span className="ms-2">Updating...</span>
                                    </>
                                    : <>Update Settings</>
                            }
                        </button>
                    </div>
                </div>
                <div className="card-body border-top px-9 pt-10 pb-4">

                    <div className="mt-10" style={{
                        maxWidth: 1000
                    }}>
                        <ToggleSwitch label="Use custom amount for monthly subscription!"
                            raw small className="mb-5"
                            checked={customSubscriptionCharge}
                            onChange={e => customSubscriptionChargeSet(e)} />

                        {
                            customSubscriptionCharge &&
                            <TextBox id="txt-custom-sub-charge" key="txt-custom-sub-charge"
                                label="Custom Charge" block
                                money name="customSubscriptionCharge" icon="dollar-sign"
                                value={props.model?.customSubscriptionCharge}
                            />
                        }

                    </div>

                </div>
            </div>
        </Form>
    )
}